import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import Loader from 'components/layout/Loader';
import Breadcrumb from 'components/layout/Breadcrumb';
import CommissionInvoiceView from 'components/layout/CommissionInvoiceView';

import Data from 'components/Data';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class CommissionInvoiceDetails extends React.Component {
  render() {
    const {
      intl: { messages },
      appIntl,
      match,
      data,
    } = this.props;
    return (
      <DocMeta tags={generateMetaTags(messages.meta.bill_details)}>
        <div class="container-fluid padding-25 sm-padding-10">
          <Data dataName="commissionInvoice" url={'/api/commissions/sales/' + match.params.invoiceId + '/view.json'} data={data} />

          <Breadcrumb
            crumbs={[
              { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
              { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
              { link: appIntl.urlPrefix + 'account/settings/commissionServiceInvoices', name: messages.commission_service_documents },
              { link: null, name: !data.pending && data.data.number_prefix + data.data.number },
            ]}
            className="p-t-0"
          />

          {data.pending ? <Loader /> : <CommissionInvoiceView data={data.data} />}
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.data.commissionInvoice,
  };
};

export default injectIntl(connect(mapStateToProps)(CommissionInvoiceDetails));
